import { Component, ViewChild, Renderer, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { IChangeCallback } from '../../_entities';
import { PopoverInput, IDropdownItem } from './base/popover-input';
import { HttpService } from '../../core/http/http.service';

@Component({
	selector: 'popover-dropdown',
	template: require('./popover-dropdown.component.html')
})
export class PopoverDropdownComponent extends PopoverInput  {

	constructor(private httpService: HttpService) { super() }

	@Input() items: any[];

	@Input() emptyText: string = "(Not set)";

	@Input('itemsUrl')
	set itemsUrl(url: string) {
		this.httpService.get<any[]>(url).then(result => this.items = result);
	};

	@Input() valueField: string = "id";
	@Input() textField: string = "name";

	get displayText() {
		if (!this.items) {
			return "Loading...";
		} else {
			const item = this.items.find(r => r[this.valueField] === this.originalValue);

			if (item)
				return item[this.textField];

			if (this.originalValue && item == null)
				return "!! " + this.dirtyValue;

			return " ";
		}
	
	}

	get selectedItem() {
		if (this.items) {
			if (this.allowEmpty && !this.dirtyValue)
				return null;
			else
				return this.items.find(r => r[this.valueField] === this.dirtyValue);

		} else {
			return null;
		}
	}

	set selectedItem(val: IDropdownItem) { this.dirtyValue = val[this.valueField]; }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-dropdown.component.ts